import { useQuery, useQueryClient } from '@tanstack/react-query';

export const usePassport = (id) => {
  const API_URL = import.meta.env.VITE_API_URL;
  const queryClient = useQueryClient();

	const { data : passport, isPending  } = useQuery({
  	queryKey: ['passport', id],
  	queryFn: async () => {
  		if (!id) return null;
			
			const params = new URLSearchParams();
			params.append("childId", id);

   		const response = await fetch(`${API_URL}/bbs/ajax.get_passport.php`, {
      		method: 'POST',
      		headers: {
            'Content-Type': 'application/json',
          },
          body: params,
      		credentials: 'include'
    		});

      	if (!response.ok) throw new Error("네트워크 오류");

  	  	return response.json();
  	},
  	enabled: !!id,
  	staleTime: 0,
  	refetchOnWindowFocus: false,
  	retry: false
	});

	return {
		passport: passport?.data ?? null,
		existPassword: passport?.data?.existPassword === true,
	  existPassport: passport?.success === true,
	  isPassportLoading: isPending,
	};
};